import { inject, makeStateKey, Provider, TransferState } from '@angular/core';
import { AuthService } from 'zenith/auth';
import { REQUEST } from 'zenith/context';
import env from 'zenith/env';
import { TENANTS_STATE_TOKEN, TenantsState, TenantInfo } from '@core/token/tenant.token';

const TENANTS_STATE_KEY = makeStateKey<TenantsState>('user-tenants-state');

export function provideUserTenants(): Provider[] {
  return [
    {
      provide: TENANTS_STATE_TOKEN,
      useFactory: () => {
        const transferState = inject(TransferState);
        const authService = inject(AuthService);
        const request = inject(REQUEST, { optional: true });

        if (transferState.hasKey(TENANTS_STATE_KEY)) {
          return transferState.get(TENANTS_STATE_KEY, { currentTenantId: null, tenants: [] });
        }

        const user = authService.getCurrentUser();
        const userTenantIds = user?.getTenants() ?? [];
        const globalTenants = env.TENANTS;

        const filteredTenants: TenantInfo[] = globalTenants
          .filter(t => userTenantIds.includes(t.id))
          .map(t => ({
            id: t.id,
            name: t.name,
            domain: t.host,
          }));

        const currentTenantId = (request as { tenant?: { id: string } })?.tenant?.id ?? null;

        const state: TenantsState = {
          currentTenantId,
          tenants: filteredTenants,
        };

        transferState.set(TENANTS_STATE_KEY, state);
        return state;
      },
    },
  ];
}
